import '../css/main.css'
import { Link, useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faCircleXmark, faSortDown, faSortUp, faWindowMinimize } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from 'react';
import NewPage from '../common/NewPage'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { changeLogId, checkLogin } from '../../store';
import { SyncLoader } from "react-spinners";
import Message from '../common/message';
import { changeNum, formatDateTime } from '../common/function';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

// dayjs 설치되어 있다면 사용 (npm i dayjs)
// import dayjs from 'dayjs';

function LogAccess() {
    let dark = useSelector((state) => state.Darkmode.value);
    let log_id = useSelector((state) => state.log_id.value);

    const [search, setSearch] = useState(String(log_id).length > 0 ? String(log_id) : "");
    const [select, setSelect] = useState(false);
    const [selectValue, setSelectValue] = useState("ID");

    const [page, setPage] = useState(1);
    const [totalpage, setTotalPage] = useState(1);

    const [reload, setReload] = useState(false);

    const [spinner, setSpinner] = useState(false);
    const [message, setMessage] = useState({ code: -1, msg: "" });

    const [data, setData] = useState([]);

    const [dateBtn, setDateBtn] = useState(0);
    const [selectedDate, setSelectedDate] = useState(() => {
        const d = new Date();
        d.setDate(d.getDate() - 1);
        return d;
    });
    const [selectedDate1, setSelectedDate1] = useState(() => new Date());

    // 다크모드 클래스
    const darkname = dark ? 'dark' : "";

    // Redux / 라우터
    let dispatch = useDispatch();
    const navigate = useNavigate();

    // ------------------ 로그인 체크 ------------------
    useEffect(() => {
        const objString = localStorage.getItem('token');
        if (objString != null) {
            const obj = JSON.parse(objString);
            if (Date.now() > obj.expire) {
                localStorage.removeItem('token');
                dispatch(checkLogin(false));
                navigate('/');
            } else {
                dispatch(checkLogin(true));
            }
        } else {
            dispatch(checkLogin(false));
            navigate('/');
        }
    }, []);

    // ------------------ 검색 인풋 ------------------
    const onChangeSearch = (e) => {
        setSearch(e.target.value);
    };
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            // 엔터 시 재조회
            setReload((prev) => !prev);
        }
    };

    // Redux에 있던 log_id 리셋
    useEffect(() => {
        setTimeout(() => {
            dispatch(changeLogId(""));
        }, 100);
    }, []);

    // ------------------ 데이터 조회 (reload 시) ------------------
    useEffect(() => {
        UpgradeData();
    }, [page]);

    useEffect(() => {
        setPage(1);
        UpgradeData();
    }, [reload, selectedDate, selectedDate1]);

    const UpgradeData = async () => {
        console.log(formatDateTime(selectedDate))
        setSpinner(true);
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/log/access', {
                params: {
                    page: page,
                    pageSize: 20,
                    startDate: formatDateTime(selectedDate),
                    endDate: formatDateTime(selectedDate1),
                    userId: search
                }
            });
            let tmp = response.data;
            if (tmp?.code === 1000) {
                setData(tmp?.data?.log ?? []);
                setTotalPage(tmp?.data?.pagination?.total ?? 0)
            }
        } catch (error) {
            console.log(error);
        }
        setSpinner(false);
    };

    // ------------------ 엑셀 다운로드 ------------------
    const excelBtn = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/log/access/excel', {
                params: {
                    startDate: formatDateTime(selectedDate),
                    endDate: formatDateTime(selectedDate1),
                    userId: search
                }
            });
            let tmp = response.data;
            if (tmp?.code === 1000) {
                excelData(tmp?.data?.log ?? [])
            }
        } catch (error) {
            console.log(error);
        }
    };

    const excelData = (exData) => {
        let arr = [];

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]

                arr.push({
                    "no": t.id,
                    "유저아이디": t.user_id,
                    "접속시간": t.access_date,
                    "접속아이피": t.access_ip,
                })
            }
        }
        Excel(arr)
    };

    return (
        <div className='main'>
            <Message message={message} />
            <div className={`main-box ${darkname}`}>
                {/* 상단 검색 바 */}
                <div className='member-1'>
                    <div className={`member-2-search ${darkname}`}>
                        {/* 검색 구분 - ID */}
                        <div className={`member-1-select ${darkname}`} onClick={() => setSelect((e) => !e)}>
                            <div className={`member-1-select-1 ${darkname}`}>{selectValue}</div>
                            {select ? (
                                <FontAwesomeIcon icon={faSortUp} />
                            ) : (
                                <FontAwesomeIcon icon={faSortDown} />
                            )}
                            {select && (
                                <>
                                    <div className='modal' onClick={() => setSelect(true)}></div>
                                    <div className={`member-1-select-box ${darkname}`}>
                                        <div
                                            onClick={() => {
                                                setSelectValue("ID");
                                                setSelect(true);
                                            }}
                                        >
                                            ID
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        <FontAwesomeIcon icon={faWindowMinimize} className='line' />

                        {/* 검색 인풋 */}
                        <div className={`member-2-search-1 ${darkname}`}>
                            <input
                                value={search}
                                onChange={onChangeSearch}
                                placeholder='Search'
                                onKeyDown={handleKeyPress}
                            />
                            <FontAwesomeIcon icon={faMagnifyingGlass} className='member-1-search-ico-3' />
                            {search.length > 0 && (
                                <FontAwesomeIcon
                                    icon={faCircleXmark}
                                    className='member-1-search-ico-2'
                                    onClick={() => setSearch("")}
                                />
                            )}
                        </div>
                    </div>

                    <div className={`search-btn ${darkname}`} onClick={() => setReload((prev) => !prev)}>
                        Search
                    </div>

                    {/* 날짜+시간 선택 버튼 */}
                    <div className={`modal-3-1-left ${darkname}`} style={{ marginLeft: "10px" }}>
                        {/* Today 버튼 */}
                        <div
                            className={dateBtn === 1 ? "modal-3-1-left-1 on" : "modal-3-1-left-1"}
                            onClick={() => {
                                setDateBtn(1);

                                // 오늘 00시
                                const todayStart = new Date();
                                todayStart.setHours(0, 0, 0, 0);

                                // 지금 시각
                                const now = new Date();

                                setSelectedDate(todayStart);
                                setSelectedDate1(now);
                            }}
                        >
                            Today
                        </div>

                        {/* 직접 날짜+시간 선택 */}
                        <div
                            className={dateBtn === 5 ? "modal-3-1-left-1 on flex" : "modal-3-1-left-1 flex"}
                            onClick={() => setDateBtn(5)}
                            style={{ gap: "5px" }}
                        >
                            {/* 시작일 + 시간 */}
                            <DatePicker
                                selected={selectedDate}
                                onChange={(date) => setSelectedDate(date)}
                                dateFormat="yyyy-MM-dd HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={30}
                                className="datepicker-input"
                                placeholderText="시작일/시간 선택"
                                shouldCloseOnSelect
                                // minDate={new Date("2000-01-01")}
                                maxDate={selectedDate1}
                            />
                            <div>~</div>
                            {/* 종료일 + 시간 */}
                            <DatePicker
                                selected={selectedDate1}
                                onChange={(date) => setSelectedDate1(date)}
                                dateFormat="yyyy-MM-dd HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={30}
                                className="datepicker-input"
                                placeholderText="종료일/시간 선택"
                                shouldCloseOnSelect
                                minDate={selectedDate}
                            // maxDate={new Date()}
                            />
                        </div>
                    </div>
                </div>

                {/* 엑셀 다운로드 */}
                <div className='excel' style={{ marginTop: "10px", width: "1200px" }}>
                    <div className={`excel-btn ${darkname}`} onClick={() => excelBtn()}>
                        Excel download
                    </div>
                </div>

                {/* 테이블 영역 */}
                <div className={`member-2 ${darkname}`} style={{ width: "1200px" }}>
                    {/* 테이블 헤더 */}
                    <div className={`table-head ${darkname}`}>
                        <div style={{ width: "10%", minWidth: "100px" }}>no.</div>
                        <div style={{ width: "10%", minWidth: "120px" }}>유저 아이디</div>
                        <div style={{ width: "20%", minWidth: "200px" }}>접속 시간</div>
                        <div style={{ width: "30%", minWidth: "300px" }}>접속 아이피</div>
                        <div>비고</div>
                    </div>

                    <div className='table-body' style={{ minHeight: "600px" }}>
                        {spinner ? (
                            <div className='spinner-modal'>
                                <SyncLoader color="#003577" />
                            </div>
                        ) : data.length === 0 ? (
                            <div className='data-nofound'>
                                <img src='/img/img_nofound.png' alt="nofound-light" />
                                <img src='/img/img_nofound_dark.svg' style={{ display: "none" }} alt="nofound-dark" />
                                <p>NO RECORDS FOUND.</p>
                            </div>
                        ) : (
                            <>
                                {data.map((a, i) => (
                                    <MemberItem key={i} item={a} darkname={darkname} dark={dark} />
                                ))}
                                <NewPage initialData={totalpage} page={page} setPage={setPage} maxFirstPage={20} />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

function MemberItem({ item, darkname, dark }) {
    return (
        <div className={`table-body-tr ${darkname}`}>
            <div className='td' style={{ width: "10%", minWidth: "100px" }}>
                {item.id}
            </div>
            <div className='right td' style={{ width: "10%", minWidth: "120px" }}>
                {item.user_id}
            </div>
            <div className='td' style={{ width: "20%", minWidth: "200px" }}>
                {item.access_date}
            </div>
            <div className='td' style={{ width: "30%", minWidth: "300px" }}>
                {item.access_ip}
            </div>
            <div className='td'></div>
        </div>
    );
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = '접속 로그';

    const headerRow = ["no", "유저아이디", "접속시간", "접속아이피"];
    const bodyRows = excelData.map((data) => [data.no, data.유저아이디, data.접속시간, data.접속아이피]);

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // 컬럼 너비
    ws['!cols'] = Array(headerRow.length).fill({ wpx: 120 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default LogAccess;
